interface OAuthAuthorizeBootstrapLocation {
	hash: string;
	pathname: string;
	search: string;
}

interface OAuthAuthorizeBootstrapHistory {
	replaceState(data: unknown, unused: string, url?: URL | null | string): void;
	readonly state: unknown;
}

const EXTERNAL_OAUTH_AUTHORIZE_PATH = /^\/oauth\/authorize\/[^/]+$/u;

const hasUsableHashRoute = (hash: string): boolean => hash.startsWith('#/');

export const bridgeExternalOAuthAuthorizeRoute = (
	location: OAuthAuthorizeBootstrapLocation = window.location,
	history: OAuthAuthorizeBootstrapHistory = window.history
): boolean => {
	if (!EXTERNAL_OAUTH_AUTHORIZE_PATH.test(location.pathname) || hasUsableHashRoute(location.hash)) {
		return false;
	}

	history.replaceState(history.state, '', `/#${location.pathname}${location.search}`);
	return true;
};
